import * as Sentry from '@sentry/browser'
import { captureEvent } from '../metrics/captureEvent'

const win = /** @type {import('../default/ga4').CustomWindow} */ (window)

/**
 * Captures loaded event
 */
export function captureLoaded() {
  const event = 'loaded'

  const intervalId = setInterval(() => {
    if (Sentry && typeof win.gtag === 'function') {
      captureEvent(event)
      clearInterval(intervalId)
    }
  }, 500)
}
